import settings from "../settings"
import axios from "axios"
import transformOptions from "../helpers/transformOptions"

export function reportHasErrored(bool) {
	return {
		type: "REPORT_HAS_ERRORED",
		hasErrored: bool,
	}
}

export function reportIsLoading(bool) {
	return {
		type: "REPORT_IS_LOADING",
		isLoading: bool,
	}
}

export function homesFetchSuccess(homes) {
	//console.log(homes)
	return {
		type: "FETCH_HOMES_SUCCESS",
		homes: homes,
	}
}

export function payloadFetchSuccess(payload) {
	//console.log(payload)
	return {
		type: "FETCH_PAYLOAD_SUCCESS",
		payload: payload,
	}
}

export function navigatorFetchSuccess(payload) {
	//console.log(payload)
	return {
		type: "FETCH_NAVIGATOR_SUCCESS",
		payload: payload,
	}
}

export function payloadHasErrored(bool) {
	return {
		type: "PAYLOAD_HAS_ERRORED",
		hasErrored: bool,
	}
}

export function navigatorHasErrored(bool) {
	return {
		type: "NAVIGATOR_HAS_ERRORED",
		hasErrored: bool,
	}
}

export function homes(url) {
	return (dispatch) => {
		dispatch(reportIsLoading(true))
		fetch(url)
			.then((response) => {
				if (!response.ok) {
					throw Error(response.statusText)
				}

				dispatch(reportIsLoading(false))

				return response
			})
			.then((response) => response.json())
			.then((homes) => dispatch(homesFetchSuccess(homes)))
			.catch(() => dispatch(reportHasErrored(true)))
	}
}

export function updateDates(currentDates) {
	return {
		type: "UPDATE_DATES",
		currentDates,
	}
}

export function updateCompareDates(compareDates) {
	return {
		type: "UPDATE_COMPARE_DATES",
		compareDates,
	}
}

export function overlayStatus(payload) {
	return {
		type: "UPDATE_OVERLAY",
		overlayStatus: payload,
	}
}

export function navigatorOverlayStatus(status) {
	return {
		type: "UPDATE_NAVIGATOR_OVERLAY",
		overlayStatus: status,
	}
}

export function payloadStatus(payload) {
	return {
		type: "UPDATE_PAYLOAD_STATUS",
		payload: payload,
	}
}

export function navigatorStatus(status) {
	return {
		type: "UPDATE_NAVIGATOR_STATUS",
		status: status,
	}
}

export function loadingStatus(payload) {
	return {
		type: "UPDATE_LOADING_OVERLAY",
		loadingStatus: payload,
	}
}

export function loadingStatusMessage(payload) {
	return {
		type: "UPDATE_LOADING_MESSAGE",
		loadingStatusMessage: payload,
	}
}

export function compareStatus(payload) {
	return {
		type: "UPDATE_COMPARE_STATUS",
		compareStatus: payload,
	}
}

export function buildInitialTrafficRow() {
	return (dispatch) => {
		fetch(settings.ep + "/trafficSources")
			.then((response) => {
				if (!response.ok) {
					throw Error(response.statusText)
				}
				return response
			})
			.then((response) => response.json())
			.then((trafficSources) => {
				var trafficOptions = transformOptions(trafficSources)
				var template = {
					label: "Traffic Row",
					id: "traffic",
					type: "traffic",
					options: trafficOptions,
					value: {},
					valid: false,
				}
				var rows = {
					template: template,
					sources: trafficOptions,
					numRows: 1,
					valid: false,
					rows: [template],
				}
				dispatch(updateTrafficRows(rows))
			})
			.catch(() => dispatch(reportHasErrored(true)))
	}
}

export function validateTrafficRows(rows, model) {
	console.log(rows)
	return (dispatch) => {
		var formValid = true
		rows.rows.forEach((r) => {
			// First ensure all the fields are there
			model.forEach(function (key) {
				if (!r.value.hasOwnProperty(key)) {
					//console.log(`${key} isn't set.`)
					// Value of this field hasn't been touched yet, it's invalid
					formValid = false
				}
			})
			// Since everything is required in traffic, loop through and make sure they're all filled out
			Object.keys(r.value).forEach(function (key) {
				if (!r.value[key]) {
					console.log(`${key} isn't set.`)
					// value not set, flag it
					formValid = false
				}
			})
		})

		rows.valid = formValid
		//console.log(rows)
		dispatch(updateTrafficRows(rows))
	}
}

export function updateTrafficRows(rows) {
	// this sets the entire trafficRows
	return {
		type: "BUILD_TRAFFIC_ROW_SUCCESS",
		trafficRowArray: rows,
	}
}

export function storeUserInfo(payload) {
	return {
		type: "STORE_USER_INFO",
		payload,
	}
}

// This takes in dates and returns all the sales, cancels, closings, etc.
export async function getPayload(options) {
	var userToken = ""
	if (localStorage.getItem("viewAs")) {
		userToken = localStorage.getItem("viewAs")
	} else {
		userToken = localStorage.getItem("user")
	}

	return (dispatch, getState) => {
		var store = getState()
		//console.log(store)
		var payloadOptions = {
			ep: settings.ep + "/getPayload",
			currentDates: {
				start: store.currentDates.startText,
				end: store.currentDates.endText,
				startStamp: store.currentDates.startStamp,
				endStamp: store.currentDates.endStamp,
			},
			compareDates: {
				start: store.compareDates.startText,
				end: store.compareDates.endText,
				startStamp: store.compareDates.startStamp,
				endStamp: store.compareDates.endStamp,
			},
			activeProperties: store.activeProperties,
			options,
		}
		//console.log(payloadOptions)
		dispatch(overlayStatus(true))
		dispatch(payloadStatus(false))
		const ax = axios.create()
		ax.defaults.timeout = 120000
		ax.post(payloadOptions.ep, payloadOptions, { headers: { Authorization: `Bearer ${userToken}` } })
			.then((response) => {
				//console.log(response.data)
				if (response.data.status == 403) {
					localStorage.removeItem("user")
				}
				if (response.data.status !== 200) {
					throw Error(response.statusText)
				}

				dispatch(overlayStatus(false))

				return response.data
			})
			//.then((response) => response.json())
			.then((payload) => {
				dispatch(payloadFetchSuccess(payload))
				dispatch(payloadStatus(true))
			})
			.catch((err) => {
				console.error(err)
				dispatch(payloadHasErrored(true))
			})
	}
}

export function getWeeklyPayload(key) {
	return (dispatch) => {
		var payloadOptions = {
			ep: settings.ep + "/getWeeklyPayload",
			key: key,
		}
		//console.log(payloadOptions)
		dispatch(overlayStatus(true))
		dispatch(payloadStatus(false))
		const ax = axios.create()
		ax.defaults.timeout = 120000
		ax.post(payloadOptions.ep, payloadOptions)
			.then((response) => {
				//console.log(response.data)
				if (response.data.status !== 200) {
					throw Error(response.statusText)
				}

				dispatch(overlayStatus(false))

				return response.data
			})
			//.then((response) => response.json())
			.then((payload) => {
				dispatch(payloadFetchSuccess(payload.data))
				dispatch(payloadStatus(true))
			})
			.catch((err) => {
				console.log(err)
				dispatch(payloadHasErrored(true))
			})
	}
}

export function getExecWeeklyPayload(key) {
	return (dispatch) => {
		var payloadOptions = {
			ep: settings.ep + "/getExecWeeklyPayload",
			key: key,
			useInputDate: settings?.weekly?.useInputDate,
		}
		let userToken = localStorage.getItem("user")
		//console.log(payloadOptions)
		dispatch(overlayStatus(true))
		dispatch(payloadStatus(false))
		const ax = axios.create()
		ax.defaults.timeout = 120000
		ax.post(payloadOptions.ep, payloadOptions, { headers: { Authorization: `Bearer ${userToken}` } })
			.then((response) => {
				//console.log(response.data)
				if (response.data.status !== 200) {
					throw Error(response.statusText)
				}

				dispatch(overlayStatus(false))

				return response.data
			})
			//.then((response) => response.json())
			.then((payload) => {
				dispatch(payloadFetchSuccess(payload.data))
				dispatch(payloadStatus(true))
			})
			.catch((err) => {
				console.log(err)
				dispatch(payloadHasErrored(true))
			})
	}
}

export async function getExecWeeklyPayloadInternal(key) {
	return async (dispatch) => {
		var payloadOptions = {
			ep: settings.ep + "/getExecWeeklyPayload",
			key: key,
		}
		let userToken = localStorage.getItem("user")
		dispatch(overlayStatus(true))
		const ax = axios.create()
		ax.defaults.timeout = 120000
		let data = await ax.post(payloadOptions.ep, payloadOptions, { headers: { Authorization: `Bearer ${userToken}` } })
		dispatch(overlayStatus(false))
		return data
	}
}

export function getNavigator() {
	return (dispatch) => {
		var payloadOptions = {
			ep: settings.ep + "/navigator",
		}
		dispatch(navigatorOverlayStatus(true))
		dispatch(navigatorStatus(false))
		const ax = axios.create()
		ax.defaults.timeout = 120000
		ax.post(payloadOptions.ep)
			.then((response) => {
				if (response.data.status !== 200) {
					throw Error(response.statusText)
				}

				dispatch(navigatorOverlayStatus(false))

				return response.data
			})
			//.then((response) => response.json())
			.then((payload) => {
				dispatch(navigatorFetchSuccess(payload))
				dispatch(navigatorStatus(true))
			})
			.catch((err) => {
				console.log(err)
				dispatch(navigatorHasErrored(true))
			})
	}
}

export function setActiveProperties(obj) {
	return {
		type: "SET_ACTIVE_PROPERTIES",
		payload: obj,
	}
}

export function setViewAs(id) {
	return {
		type: "SET_VIEW_AS",
		payload: id,
	}
}

export function setTableExporting(obj) {
	return {
		type: "SET_TABLE_EXPORTING",
		payload: obj
	}
}
